// extracted by mini-css-extract-plugin
module.exports = {"top":"ScrollToTop-module--top--2p-pN","visible":"ScrollToTop-module--visible--kSaYZ ScrollToTop-module--top--2p-pN"};